<template>
	<v-container class="mt-4 px-5" fluid>
	  <v-row justify="center"> 
	  	<v-col cols="12" sm="8">
			<!--ICONO DE AVATAR-->
	  		<v-card class="mx-auto px-4 mb-n16  transparent elevation-0 " align="center" style="z-index: 1;">
          <v-avatar size="180" color="transparent">
				    <avataaars ></avataaars>
          </v-avatar>
			</v-card>

			<!--INFO USUARIO-->
			<v-card  class="shadowCard  separacionAlta text-center pb-4">
				<div>
					<div class="mb-0 font-weight-bold colorCurso text-body-1" >
						<strong>{{ getdatosUsuarioERPERP.nombre_completo }}</strong>
					</div>

					<p class="mb-0 font-weight-bold">
						<strong>{{ getdatosUsuarioERPERP.email }}</strong>
					</p>

					<v-btn color="orange" @click="irCapacitacion()" dark tile small>Ir a capacitación</v-btn>
				</div>
				<div v-if="faltaInfoDispo || faltaNiveles || faltaSucursal">
					<br>
					<v-alert border="top" colored-border color="primary"  elevation="2" type="info">
						¡Falta informacion de llenar! Haz clic en la pestaña: {{ Infotabs }}  para revisar la informacion.

						<br/>

						Una vez llena tu información, favor de actualizar tu plataforma con F5, saludos!
					</v-alert>
				</div>
				<v-divider class="ma-0 mt-4 mb-6"></v-divider>
				<v-tabs	v-model="tab" background-color="transparent" centered> 
					<v-tab v-for="nombreTab in tabs" :key="nombreTab">
						{{ nombreTab }}
					</v-tab>
				</v-tabs>
				<br>
				<v-tabs-items v-model="tab">
					<v-tab-item href="#tab-1">
						<div class="" v-if="datosPersonales">
							<!-- <label class="grey--text">Nombre completo</label>
							<br/>
							<b class="text-subtitle-1">{{ getdatosUsuarioERPERP.nombre_completo }}</b>

							<br/> <br/> -->

							<label class="grey--text">Tarjeta</label>
							<br/>
							<b class="text-subtitle-1">{{ datosPersonales.numero_tarjeta }}</b>

							<br/> <br/>

							<label class="grey--text">Banco</label>
							<br/>
							<b class="text-subtitle-1">{{ datosPersonales.banco }}</b>

							<br/> <br/>

							<label class="grey--text">Teléfono</label>
							<br/>
							<b class="text-subtitle-1">{{ datosPersonales.telefono1 }}</b>

							<br/> <br/>
							
							<label class="grey--text">Ciclo Actual</label>
							<br/>
							<b class="text-subtitle-1">{{ cicloActual.ciclo }}</b>

							<br/> <br/>

							<label class="grey--text">Categoría</label>
							<br/>
							<b class="text-subtitle-1">{{ datosPersonales.categoria }}</b>

							<br/> <br/>

							<label class="grey--text">Estatus</label>
							<br/>
							<v-chip color="green"  small dark v-if="aceptado == 1">Aceptado</v-chip>
							<v-chip color="black"  small dark v-if="aceptado == 2">Rechazado</v-chip>
							<v-chip color="orange"  small dark v-if="aceptado == 0">Pendiente</v-chip>

							<br/> <br/>

						</div>
						<v-card-text v-if="aceptado == 0 || aceptado == 2">
							<v-btn color="red" dark tile small class="mr-2" @click="updateDatos(2)">
								Rechazar
							</v-btn>	  	

							<v-btn color="success" tile small @click="updateDatos(1)" >
								Aceptar
							</v-btn>
						</v-card-text>
					</v-tab-item>
					<v-tab-item href="#tab-2">
						<!--PLANTELES USUARIO-->
						<v-card>
							<v-alert border="top" colored-border color="primary"  elevation="2" type="info">
								Selecciona las sucursales donde puedes impartir clases. Recuerda seleccionarlas en el orden de prioridad que prefieras, siendo el 1 la sucursal con mayor prioridad para ti.
							</v-alert>
							<v-card-title primary-title class="pb-0">
								Sucursales
							</v-card-title>
							<v-card-text>
								<v-row>
									<v-col>
										Todas las sucursales:
										<v-data-table v-model="selectSucursal" :headers="headersSuc" :items="sucursales" item-key="idplantel" show-select color="primary"
											class="elevation-1" dense mobile-breakpoint="200" fixed-header height="290" :items-per-page="sucursales.length" hide-default-footer>
										</v-data-table>
									</v-col>
									<v-col>
										Prioridad:
										<v-data-table :headers="headersSucPr" :items="selectSucursal" item-key="idplantel" color="primary" class="elevation-1" 
											dense mobile-breakpoint="200" fixed-header height="290" :items-per-page="sucursales.length" hide-default-footer>
										</v-data-table>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item href="#tab-3">
						<!--NIVELES USUARIO-->
						<v-card class="my-3">
							<v-alert border="top" colored-border color="primary"  elevation="2" type="info">
								Selecciona los niveles que puedes impartir. Asegurate de seleccionar los niveles correspondientes a cada escuela, ya sea INBI o FAST.
							</v-alert>
							<v-card-title primary-title class="pb-0">
								Niveles
							</v-card-title>
							<v-card-text>
								<v-data-table v-model="selectNivel" :headers="headersNivel" :items="niveles" item-key="idniveles" show-select color="primary" 
									class="elevation-1" dense mobile-breakpoint="200" fixed-header height="290" :items-per-page="niveles.length" hide-default-footer>
									<template v-slot:item.curso="{ item }">
										<v-chip small dark color="blue lighten-2" v-if="item.esTeens==1">Teens</v-chip>
										<v-chip small dark color="blue lighten-2" v-else-if="item.esKids==1">Kids</v-chip>
										<v-chip small dark color="blue lighten-2" v-else>Adultos</v-chip>
									</template>
									<template v-slot:item.unidad_negocio="{ item }">
										<v-chip small dark color="blue lighten-2" v-if="item.unidad_negocio==1">INBI</v-chip>
										<v-chip small dark color="blue darken-2" v-else>FAST</v-chip>
									</template>
									<template v-slot:item.nivel="{ item }">
										<span>{{ item.nombrenivel }}</span>
									</template>
								</v-data-table>
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item href="#tab-4">
						<!--DISPONIBILIDAD USUARIO-->
						<v-card class="my-3">
							<v-alert border="top" colored-border color="primary"  elevation="2" type="info">
								Utiliza el botón de 'Agregar Horario' para añadir las horas en las que estás disponible para dar clases. En el panel de abajo, podrás consultar y eliminar la información que vayas agregando.
							</v-alert>
							<v-card-title primary-title class="pb-0">
								Disponibilidad
								<v-spacer></v-spacer>
								<v-btn color="orange" dark tile small  @click="dialogHoraAdd()" :disabled="guardandoHora || eliminandoHora">
									<v-icon small left>mdi-calendar-clock</v-icon>
									Agregar horario
								</v-btn>
							</v-card-title>

							<v-card-text class="mt-6">
								<v-row>
									<v-col cols="12" sm="6" lg="4" xl="3" v-for="(dia, i) in dias" :key="i">
										<v-card class="shadowCard">
											<v-card-title primary-title>
												{{ dia.dia }}
												<v-spacer></v-spacer>
											</v-card-title>
											<v-card-text>
												<v-container class="ma-0 pa-0">
													<v-data-table dense
														:headers="headers" :items="dispUsuarioFiltrada[dia.valor] || []"
														item-key="iddisponibilidad_usuario" class="elevation-0"
														hide-default-footer :items-per-page="100"
														:mobile-breakpoint="200"
													>
														<template v-slot:item.inicio="{ item }">
															{{ normalizarHora(item.inicio) }}
														</template>
														<template v-slot:item.fin="{ item }">
															{{ normalizarHora(item.fin) }}
														</template>
														<template v-slot:item.actions="{ item }">
															<v-icon small @click="deleteItem(item)" color="primary"> mdi-delete </v-icon>
														</template>
													</v-data-table>	 
												</v-container>	  
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item href="#tab-5">
						<!--COBERTURA USUARIO-->
						<v-card class="my-3">
							<v-alert border="top" colored-border color="primary"  elevation="2" type="info">
								<strong>La cobertura es el horario en el que puedes ir a cubrir clases.</strong> Este horario <strong>no forma parte de tu horario oficial de clases</strong>, sino que es un horario adicional en el que estás disponible para cubrir clases cuando sea necesario.
								<br/><br/>
								Utiliza el botón de 'Agregar Horario' para añadir las horas de cobertura. En el panel de abajo, podrás consultar y eliminar la información que vayas agregando.
							</v-alert>
							<v-card-title primary-title class="pb-0">
								Cobertura
								<v-spacer></v-spacer>
								<v-btn color="orange" dark tile small  @click="dialogHoraCoberturaAdd()" >
									<v-icon small left>mdi-calendar-clock</v-icon>
									Agregar horario
								</v-btn>
							</v-card-title>

							<v-card-text class="mt-6">
								<v-row>
									<v-col cols="12" sm="6" lg="4" xl="3" v-for="(dia, i) in dias" :key="'cobertura-' + i">
										<v-card class="shadowCard">
											<v-card-title primary-title>
												{{ dia.dia }}
												<v-spacer></v-spacer>
											</v-card-title>
											<v-card-text>
												<v-container class="ma-0 pa-0">
													<v-data-table dense
														:headers="headers" :items="coberturaUsuarioFiltrada[dia.valor] || []"
														item-key="iddisponibilidad_cobertura" class="elevation-0"
														hide-default-footer :items-per-page="100"
														:mobile-breakpoint="200"
													>
														<template v-slot:item.inicio="{ item }">
															{{ normalizarHora(item.inicio) }}
														</template>
														<template v-slot:item.fin="{ item }">
															{{ normalizarHora(item.fin) }}
														</template>
														<template v-slot:item.actions="{ item }">
															<v-icon small @click="deleteItemCobertura(item)" color="primary"> mdi-delete </v-icon>
														</template>
													</v-data-table>
												</v-container>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
				</v-tabs-items>
			</v-card>
	  	</v-col>
	  </v-row>

	 <!-- Agregar la hora -->
	<v-dialog v-model="dialogHora" max-width="350">
      <v-card>
        <v-card-title class="text-h5">
          Nuevo horario
        </v-card-title>
        <v-card-text>
        	<v-row>
        		<v-col cols="12">
        			<v-text-field name="name" label="Inicio" id="id" type="time" step="1500" v-model="horaini"></v-text-field>
        		</v-col>
        		<v-col cols="12">
        			<v-text-field name="name" label="Fin" id="id" type="time" v-model="horafin" step="1500"></v-text-field>
        		</v-col>
				<v-col cols="12" class="pb-0">
					Selecciona los dias:
				</v-col>
        		<v-col cols="6" class="py-0">
        			<v-checkbox v-model="diasSeleccionados" label="Lunes" :value="1" hide-details></v-checkbox>
				</v-col>
				<v-col cols="6" class="py-0">
					<v-checkbox v-model="diasSeleccionados" label="Martes" :value="2" hide-details></v-checkbox>
				</v-col>
				<v-col cols="6" class="py-0">
					<v-checkbox v-model="diasSeleccionados" label="Miercoles" :value="3" hide-details></v-checkbox>
				</v-col>
				<v-col cols="6" class="py-0">
					<v-checkbox v-model="diasSeleccionados" label="Jueves" :value="4" hide-details></v-checkbox>
				</v-col>
				<v-col cols="6" class="py-0">
					<v-checkbox v-model="diasSeleccionados" label="Viernes" :value="5" hide-details></v-checkbox>
				</v-col>
				<v-col cols="6" class="py-0">
					<v-checkbox v-model="diasSeleccionados" label="Sabado" :value="6" hide-details></v-checkbox>
				</v-col>
				<v-col cols="6" class="py-0">
					<v-checkbox v-model="diasSeleccionados" label="Domingo" :value="7" hide-details></v-checkbox>
        		</v-col>
        	</v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="addHora()" :loading="guardandoHora" :disabled="guardandoHora">
            Aceptar
          </v-btn>
          <v-btn color="green darken-1" text @click="dialogHora = false" :disabled="guardandoHora">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 

	<!-- Dialogo para editar la hora -->
    <!-- <v-dialog v-model="dialogHoraEditar" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5" v-if="horaEditar">
          {{dia}}
        </v-card-title>
        <v-card-text>
        	<v-row>
        		<v-col cols="12" md="6">
        			<v-text-field
        			  name="name"
        			  label="Inicio"
        			  id="id"
        			  type="time"
        			  step="1500"
        			  v-model="horaEditar.inicio"
        			></v-text-field>
        		</v-col>
        		<v-col cols="12" md="6">
        			<v-text-field
        			  name="name"
        			  label="Inicio"
        			  id="id"
        			  type="time"
        			  v-model="horaEditar.fin"
        			  step="1500"
        			></v-text-field>
        		</v-col>
        	</v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="saveHora()"
          >
            Aceptar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="dialogHoraEditar = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <!-- Eliminar la hora -->
    <v-dialog v-model="dialogDeleteHora" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Seguro que deseas eliminar esta hora?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDeleteHora = false" :disabled="eliminandoHora">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="deleteHora()" :loading="eliminandoHora" :disabled="eliminandoHora">SI</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

	<!-- Agregar la hora cobertura -->
	<v-dialog v-model="dialogHoraCobertura" max-width="350">
      <v-card>
        <v-card-title class="text-h5">
          Nuevo horario cobertura
        </v-card-title>
        <v-card-text>
        	<v-row>
        		<v-col cols="12">
        			<v-text-field name="name" label="Inicio" id="id" type="time" step="1500" v-model="horainiCobertura"></v-text-field>
        		</v-col>
        		<v-col cols="12">
        			<v-text-field name="name" label="Fin" id="id" type="time" v-model="horafinCobertura" step="1500"></v-text-field>
        		</v-col>
				<v-col cols="12" class="pb-0">
					Selecciona los dias:
				</v-col>
        		<v-col cols="6" class="py-0">
        			<v-checkbox v-model="diasSeleccionadosCobertura" label="Lunes" :value="1" hide-details></v-checkbox>
				</v-col>
				<v-col cols="6" class="py-0">
					<v-checkbox v-model="diasSeleccionadosCobertura" label="Martes" :value="2" hide-details></v-checkbox>
				</v-col>
				<v-col cols="6" class="py-0">
					<v-checkbox v-model="diasSeleccionadosCobertura" label="Miercoles" :value="3" hide-details></v-checkbox>
				</v-col>
				<v-col cols="6" class="py-0">
					<v-checkbox v-model="diasSeleccionadosCobertura" label="Jueves" :value="4" hide-details></v-checkbox>
				</v-col>
				<v-col cols="6" class="py-0">
					<v-checkbox v-model="diasSeleccionadosCobertura" label="Viernes" :value="5" hide-details></v-checkbox>
				</v-col>
				<v-col cols="6" class="py-0">
					<v-checkbox v-model="diasSeleccionadosCobertura" label="Sabado" :value="6" hide-details></v-checkbox>
				</v-col>
				<v-col cols="6" class="py-0">
					<v-checkbox v-model="diasSeleccionadosCobertura" label="Domingo" :value="7" hide-details></v-checkbox>
        		</v-col>
        	</v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="addHoraCobertura()" :loading="guardandoHoraCobertura" :disabled="guardandoHoraCobertura">
            Aceptar
          </v-btn>
          <v-btn color="green darken-1" text @click="dialogHoraCobertura = false" :disabled="guardandoHoraCobertura">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Eliminar la hora cobertura -->
    <v-dialog v-model="dialogDeleteHoraCobertura" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Seguro que deseas eliminar esta hora de cobertura?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDeleteHoraCobertura = false" :disabled="eliminandoHoraCobertura">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="deleteHoraCobertura()" :loading="eliminandoHoraCobertura" :disabled="eliminandoHoraCobertura">SI</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
		
	<!-- Dialog de carga -->
	<Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
	<carga                v-if="cargar"/>

  	</v-container>
</template>
<script>
import axios from 'axios';
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

	import Avataaars from 'vuejs-avataaars'

  export default {
  	components:{
  		Avataaars,
  		Alerta,
			carga
  	},

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
		// revisar para que sirve cada dato
		avatar:'',
		avatarParamentro: {
		editar: false
		},

		aceptado: 0,

		ciclos:[],
        cicloVer:{},
		cicloAdd:{},
		cicloActual:{},
		
		categoria_ciclo: [],
		fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

		datosPersonales: {},
		usuarios: [],
		usuario: {},
		usuarioRH: {},

		tabs: ['Informacion Personal'],
		tab:{},

		//tabla de sucursales
		sucursales:[],
      	sucursalesUsuario:[],
		selectSucursal: [],
		headersSuc: [
        	{ text: 'Sucursal',  value: 'plantel' },
		],
		headersSucPr: [
        	{ text: 'Orden',  	value: 'prioridad' },
			{ text: 'Sucursal',  value: 'plantel' },
		],
		//tabla de niveles
		niveles:[],
		nivelesUsuario:[],
		selectNivel:[],
    	headersNivel: [
			{ text: 'Nivel',      value: 'nivel' },
			{ text: 'Escuela',    value: 'unidad_negocio' },
			{ text: 'Curso',      value: 'curso' },
		],

		//tabla disponibilidad
		dias:[{dia:'Lunes', valor: 0},{dia:'Martes', valor: 1},{dia:'Miércoles', valor: 2},{dia:'Jueves', valor: 3},{dia:'Viernes', valor: 4},{dia:'Sábado', valor: 5},{dia:'Domingo', valor: 6}],
		dispUsuario: [],
		dispUsuarioFiltrada: { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] },
		dialogHora: false,
		iddisponibilidad_usuarioDelete: null,
		guardandoHora: false,
		eliminandoHora: false,
		//tabla cobertura
		coberturaUsuario: [],
		coberturaUsuarioFiltrada: { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] },
		dialogHoraCobertura: false,
		dialogDeleteHoraCobertura: false,
		iddisponibilidad_coberturaDelete: null,
		guardandoHoraCobertura: false,
		eliminandoHoraCobertura: false,
		diasSeleccionadosCobertura: [],
		horainiCobertura: '',
		horafinCobertura: '',
		dialogHoraEditar: false,
		dialogDeleteHora: false,
		diasSeleccionados : [],
		horaini:'',
		horafin:'',
		headers: [
			{ text: 'Inicio', value: 'inicio' },
			{ text: 'Fin'   , value: 'fin' },
			{ text: 'Acciones'      , value: 'actions' },
		],
		faltaNiveles:false,
		faltaSucursal:false,
		faltaInfoDispo:false,
		Infotabs: '',
    rol:[]
    }),

    computed:{
    	...mapGetters( 'login', [ 'getdatosUsuarioERPERP', 'getdatosUsuarioERPERPLMS', 'getAvatar']),

    },

	watch: {
		selectSucursal () {
			this.guardarSuc()
    	},

		selectNivel () {
			this.guardarNiv()
    	},
	},

    created() {
      console.log( this.getdatosUsuarioERPERP )
    	this.initialize()
      this.getCicloActual()
      this.getCiclos()
    },

    methods: {
    	
    	initialize( ){
			//las siguientes pestañas estan habilitadas para teachers, desarrolladores y jefe de TI
			if(this.getdatosUsuarioERPERP.idpuesto==10 || this.getdatosUsuarioERPERP.idpuesto==12 || this.getdatosUsuarioERPERP.idpuesto==11){
				this.tabs.push('Sucursales')
				this.tabs.push('Niveles')
				this.tabs.push('Disponibilidad')
				this.tabs.push('Cobertura')
			}
			// Vaciamos todo
			this.cargar = true
			this.datosPersonales = {}
			// Consultamos
			this.$http.get('usuarios.trabajador/' + this.getdatosUsuarioERPERP.iderp ).then(response=>{
				this.datosPersonales = response.data   	
				this.getCicloActual()
				this.getSucursalesUsuario()
				this.getNivelesUsuario()
				this.getDisponibilidadUsuario()
				this.getCoberturaUsuario()
			}).catch( error =>{
				this.validarError( error.response.data.message )
			}).finally( () => { 
				
			 })

			this.$http.get('planteles.all').then(response=>{
    			for(const j in response.data){
					response.data[j].fecha_creacion  = response.data[j].fecha_creacion.substr(0,10)
					response.data[j].fecha_actualizo = response.data[j].fecha_actualizo.substr(0,10)
				}
    			this.sucursales = response.data.filter(el=>el.idplantel != 0)
    		}).catch( error =>{
				this.validarError( error.response.data.message )
			}).finally( () => { this.cargar = false })

			this.$http.get('niveles.all').then(response=>{
    			for(const j in response.data){
					response.data[j].fecha_registro  = response.data[j].fecha_registro.substr(0,10)
					response.data[j].fecha_actualizo = response.data[j].fecha_actualizo.substr(0,10)
				}
    			this.niveles = response.data
    		}).catch( error =>{
				this.validarError( error.response.data.message )
			}).finally( () => { this.cargar = false })
			
    	},

		getCiclos(){
			this.$http.get('roles.ciclos.all').then(response=>{
				// hacer un ciclo ya que los ciclos vienen varios como inscripciones y todo eso
				// y solo queremos los ciclos que en su nombre dicen ciclo 
				for(const i in response.data){
					//  si es diferente a FE
					if (!(response.data[i].ciclo.search('FE') != -1)) {
					// Y es igual a FE, se agrega a ciclos
					// por qué es diferente a FE? por que es por estetica, mostrar solo los ciclos normales, ya que los ciclos tienen ligado el ciclo FE
					if(response.data[i].ciclo.search('CICLO') != -1){
						this.ciclos.push(response.data[i])
					}
					}
				}
			}).catch( error =>{
				this.validarError( error.response.data.message )
			}).finally( () => { this.cargar = false })
		},

		updateTextoFaltaInfo(){
			this.Infotabs= '';
			if(this.faltaNiveles){
				this.Infotabs = 'Niveles'
			}
			if(this.faltaSucursal){
				if(this.Infotabs != ''){
					this.Infotabs = this.Infotabs + ' | Sucursales'
				} else {
					this.Infotabs = 'Sucursales'
				}
			}
			if(this.faltaInfoDispo){
				if(this.Infotabs != ''){
					this.Infotabs = this.Infotabs + ' | Disponibilidad'
				} else {
					this.Infotabs = 'Disponibilidad'
				}
			}
		},

		getSucursalesUsuario () {
			// Vaciamos los arreglos
			this.sucursalesUsuario = []
			this.selectSucursal = []
			// this.getdatosUsuarioERPERP.idusuario este id es el usuario en la base de datos erp_db
			this.$http.get('planteles_usuario.usuario/' + this.getdatosUsuarioERPERP.idusuario).then(response=>{
				// Hacemos un ciclo para obtener los datos de los departamentos
				for(const j in response.data){
					response.data[j].fecha_creacion  = response.data[j].fecha_creacion.substr(0,10)
					response.data[j].fecha_actualizo = response.data[j].fecha_actualizo.substr(0,10)
				}
				this.sucursalesUsuario = response.data
				//Generar dos for, para saber cual nivel ya esta dando y poder agregarlo a la tabla de nieveles como activo
				for(const i in this.sucursales){
					for(const j in this.sucursalesUsuario){
						// Cpmapramos que si sea el nivel que esta dando el usuario
						if(this.sucursales[i].idplantel == this.sucursalesUsuario[j].idplantel){
							// Le asignamos la prioridad a la sucursal
							this.sucursales[i].prioridad = this.sucursalesUsuario[j].prioridad
							// Lo metemos al arreglo de usuarios sucursales
							this.selectSucursal.push(this.sucursales[i])
						}
					}
				}
				if(this.sucursalesUsuario.length == 0){
					this.faltaSucursal = true;
					this.updateTextoFaltaInfo()
				} else {
					this.faltaSucursal = false;
					this.updateTextoFaltaInfo()
				}
			}).catch( error =>{
				this.validarError( error.response.data.message )
			}).finally( () => { })
		},
		getNivelesUsuario () {
    		// Vaciamos los arreglos
    		this.nivelesUsuario = []
    		this.selectNivel = []

    		this.$http.get('niveles_usuario.usuario/' + this.getdatosUsuarioERPERP.idusuario).then(response=>{
			// Hacemos un ciclo para obtener los datos de los departamentos
			for(const j in response.data){
				response.data[j].fecha_creacion  = response.data[j].fecha_creacion.substr(0,10)
				response.data[j].fecha_actualizo = response.data[j].fecha_actualizo.substr(0,10)
			}
			this.nivelesUsuario = response.data
          // Generar dos for, para saber cual nivel ya esta dando y poder agregarlo a la tabla de nieveles como activo
          for(const i in this.niveles){
          	for(const j in this.nivelesUsuario){
          		// Cpmapramos que si sea el nivel que esta dando el usuario
          		if(this.niveles[i].idniveles == this.nivelesUsuario[j].idnivel){
          			// Lo metemos al arreglo de usuarios niveles
          			this.selectNivel.push(this.niveles[i])
          		}
          	}
          }

			if(this.nivelesUsuario.length == 0){
				this.faltaNiveles = true;
				this.updateTextoFaltaInfo()
			} else {
				this.faltaNiveles = false;
				this.updateTextoFaltaInfo()
			}
          // Cerramos la carga
          this.dialog = false
        }).catch(error=>{console.log(error)})
    	},
		normalizarHora(hora){
			if(!hora) return ''
			return String(hora).substr(0, 5)
		},

		mapearHorariosPorDia(lista){
			const filtrada = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] }
			const rows = Array.isArray(lista) ? lista : []
			for(const el of rows){
				if(el.deleted == 1) continue
				const idx = Number(el.dia) - 1
				if(idx >= 0 && idx <= 6) filtrada[idx].push(el)
			}
			return filtrada
		},

		horarioYaExiste(lista, dia, inicio, fin){
			const ini = this.normalizarHora(inicio)
			const finH = this.normalizarHora(fin)
			return (lista || []).some(el =>
				Number(el.dia) === Number(dia) &&
				this.normalizarHora(el.inicio) === ini &&
				this.normalizarHora(el.fin) === finH &&
				el.deleted != 1
			)
		},

		getDisponibilidadUsuario(){
			return this.$http.get('disponibilidad.usuario/' + this.getdatosUsuarioERPERP.idusuario).then(response=>{
				this.dispUsuario = Array.isArray(response.data) ? response.data : []
				this.dispUsuarioFiltrada = this.mapearHorariosPorDia(this.dispUsuario)
				this.faltaInfoDispo = this.dispUsuario.length == 0
				this.updateTextoFaltaInfo()
			}).catch(error=>{
				this.validarError(error)
			})
		},

		addHora () {
			if(this.guardandoHora) return
			if(!this.horaini || !this.horafin){
				this.validarErrorDirecto('Ingresa hora de inicio y fin.')
				return
			}
			if(this.horaini >= this.horafin){
				this.validarErrorDirecto('La hora de inicio debe ser menor a la hora de fin.')
				return
			}
			if(!this.diasSeleccionados || this.diasSeleccionados.length == 0){
				this.validarErrorDirecto('Selecciona al menos un día.')
				return
			}
			const diasNuevos = this.diasSeleccionados.filter(dia =>
				!this.horarioYaExiste(this.dispUsuario, dia, this.horaini, this.horafin)
			)
			if(!diasNuevos.length){
				this.validarErrorDirecto('Ese horario ya está registrado en los días seleccionados.')
				return
			}
			this.guardandoHora = true
			const peticiones = diasNuevos.map(dia => {
				const payload = {
					idusuario:        this.getdatosUsuarioERPERP.idusuario,
					inicio:           this.horaini,
					fin:              this.horafin,
					usuario_registro: this.getdatosUsuarioERPERP.iderp,
					deleted:          0,
					dia
				}
				return this.$http.post('disponibilidad.add', payload)
			})
			Promise.all(peticiones).then(()=>{
				this.dialogHora = false
				this.horaini = ''
				this.horafin = ''
				this.diasSeleccionados = []
				this.validarSuccess('Horario guardado')
				this.getDisponibilidadUsuario()
			}).catch(error=>{
				this.validarError(error)
			}).finally(()=>{
				this.guardandoHora = false
			})
		},

		guardarSuc () {
			//si se eliminan hay que updatear la prioridad de las otras
  			for(const i in this.selectSucursal){
    			const resultado = this.sucursalesUsuario.find( plantel => plantel.idplantel == this.selectSucursal[i].idplantel );
    			if(!resultado){
    				var payload = {
						idusuario: this.getdatosUsuarioERPERP.idusuario,
						idplantel: this.selectSucursal[i].idplantel,
						usuario_registro:this.getdatosUsuarioERPERP.iderp,
						fecha_creacion: this.fecha,
						fecha_actualizo: this.fecha,
						prioridad: this.selectSucursal.length,
					}
					console.log(payload)
					this.$http.post('planteles_usuario.add' , payload).then(response=>{
						this.snack = true
						this.snackColor = 'success'
						this.snackText = 'Datos guardados'
						this.getSucursalesUsuario()
					}).catch(error=>{console.log(error)})
    			}
    		}
    		// Ahora hay que eliminar todas esas que se deseleccionaron
			var prioridadSeElimino = 0;
    		for(const i in this.sucursalesUsuario){
    			const resultado = this.selectSucursal.find( plantel => plantel.idplantel == this.sucursalesUsuario[i].idplantel );
    			if(!resultado){
					prioridadSeElimino = this.sucursalesUsuario[i].prioridad
					this.$http.delete('planteles_usuario.delete/' + this.sucursalesUsuario[i].idplanteles_usuarios).then(response=>{
						this.snack = true
						this.snackColor = 'success'
						this.snackText = 'Datos guardados'
						this.getSucursalesUsuario()
					}).catch(error=>{console.log(error)})
    			} else {
					if(prioridadSeElimino > 0){
						//aqui hacemos el update de prioridad
						console.log(prioridadSeElimino)
						if(this.sucursalesUsuario[i].prioridad > prioridadSeElimino){
							var prioridad = this.sucursalesUsuario[i].prioridad -1
							console.log(prioridad)
							this.$http.put('planteles_usuario.update.prioridad/' + this.sucursalesUsuario[i].idplanteles_usuarios + '/' + prioridad).then(response=>{
								//this.getSucursalesUsuario()
							}).catch(error=>{console.log(error)})
						}
					}
				}
    		}
		},
		guardarNiv(){
			for(const i in this.selectNivel){
				const nivelUsuario = this.nivelesUsuario.find( nivel => nivel.idnivel == this.selectNivel[i].idniveles );
				//se busca el nivel seleccionado entre los que tiene el usuario
				if(!nivelUsuario){
					//si no se encuentra se inserta
					var payload = {
						idusuario:this.getdatosUsuarioERPERP.idusuario,
						idnivel: this.selectNivel[i].idniveles,
						usuario_registro: this.getdatosUsuarioERPERP.iderp,
						fecha_creacion:  this.fecha,
					    fecha_actualizo: this.fecha,
						deleted:         0,
					}
					this.$http.post('niveles_usuario.add' , payload).then(response=>{
						this.getNivelesUsuario()
					}).catch(error=>{console.log(error)})
				}
			}

			// Ahora hay que eliminar todas esas que se deseleccionaron
    		for(const i in this.nivelesUsuario){
    			const nivelUsuario = this.selectNivel.find( nivel => nivel.idniveles == this.nivelesUsuario[i].idnivel );
    			if(!nivelUsuario){
					this.$http.delete('niveles_usuario.delete/' + this.nivelesUsuario[i].idniveles_usuario).then(response=>{
						this.getNivelesUsuario()
					}).catch(error=>{console.log(error)})
    			}
    		}
		},

		dialogHoraAdd(){
			this.horaini = ''
			this.horafin = ''
			this.diasSeleccionados = []
			this.dialogHora = true
		},

		getCicloActual( ){
			this.cargar = true
			const payload = {
				fecha: this.fecha,
			};
			this.$http.post('usuarios.get.cicloactual', payload).then(response=>{
				this.cicloActual = response.data[0]
				this.cicloVer = this.cicloActual.id_ciclo
				this.cicloAdd = this.cicloActual.id_ciclo
				this.getCategoriaCiclo()
				// Consulta rol.clases con cicloActual
				this.$http.post('rol.clases', this.cicloActual).then(res=>{
					this.rol = res.data.respuesta
          console.log( this.rol[0] )
				}).catch(err=>{console.log(err)})
			}).catch( error =>{
				this.validarError( error.response.data.message )
			}).finally( () => { })
    	},

		getCategoriaCiclo( ){
			this.cargar = true
			const payload = {
				id_trabajador: this.datosPersonales.id,
				id_ciclo: this.cicloActual.id_ciclo
			};

			this.$http.post('usuarios.get.categoriaciclo', payload).then(response=>{
				this.categoria_ciclo = response.data    
				console.log(this.categoria_ciclo)
				if(this.categoria_ciclo[0]){
					this.aceptado = this.categoria_ciclo[0].estatus;
				}
			}).catch( error =>{
				this.validarError( error.response.data.message )
			}).finally( () => { this.cargar = false })

    	},

    	updateDatos( value ){
			// inicia pantalla de carga
			this.cargar = true
			// guardamos la info para el back
			const payload = {
				id_trabajador: this.datosPersonales.id,
				nombre_completo: this.getdatosUsuarioERPERP.nombre_completo,
				id_ciclo: this.cicloActual.id_ciclo,
				ciclo: this.cicloActual.ciclo,
				fecha: this.fecha,
				estatus: value
			}
			// llamamos al back
			this.$http.post('usuarios.add.categoriaciclo', payload  ).then(response=>{
				//recargamos la info
				this.initialize()
			}).catch( error =>{
				//mensaje de error
				this.validarError( error.response.data.message )
			}).finally( () => { this.cargar = false })
    	},

    	irCapacitacion( ){
    		window.open( 'https://capacitacion.schoolofenglishadmin.com/#/login/' + this.getdatosUsuarioERPERP.iderp, "_blank" )
    	},

		/*Eliminar disponibilidad*/
		deleteItem (value) {
			this.iddisponibilidad_usuarioDelete = value && value.iddisponibilidad_usuario
			if(!this.iddisponibilidad_usuarioDelete){
				this.validarErrorDirecto('No se pudo identificar el horario. Recarga la página e inténtalo de nuevo.')
				return
			}
			this.dialogDeleteHora = true
		},

		deleteHora () {
			if(this.eliminandoHora) return
			if(!this.iddisponibilidad_usuarioDelete){
				this.validarErrorDirecto('No se pudo identificar el horario. Recarga la página e inténtalo de nuevo.')
				this.dialogDeleteHora = false
				return
			}
			this.eliminandoHora = true
			this.$http.delete('disponibilidad.delete/' + this.iddisponibilidad_usuarioDelete).then(()=>{
				this.dialogDeleteHora = false
				this.iddisponibilidad_usuarioDelete = null
				this.validarSuccess('Horario eliminado')
				this.getDisponibilidadUsuario()
			}).catch(error=>{
				this.validarError(error)
			}).finally(()=>{
				this.eliminandoHora = false
			})
		},

		/* Cobertura */
		getCoberturaUsuario(){
			return this.$http.get('cobertura.usuario/' + this.getdatosUsuarioERPERP.idusuario).then(response=>{
				this.coberturaUsuario = Array.isArray(response.data) ? response.data : []
				this.coberturaUsuarioFiltrada = this.mapearHorariosPorDia(this.coberturaUsuario)
			}).catch(()=>{
				this.coberturaUsuario = []
				this.coberturaUsuarioFiltrada = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] }
			})
		},

		dialogHoraCoberturaAdd(){
			this.horainiCobertura = ''
			this.horafinCobertura = ''
			this.diasSeleccionadosCobertura = []
			this.dialogHoraCobertura = true
		},

		// Valida que el teacher no tenga clase asignada en el horario de cobertura
		validarCoberturaNoConflictiva(dia, horaini, horafin){
			const DIA_A_CAMPO = { 1: 'lunes', 2: 'martes', 3: 'miercoles', 4: 'jueves', 5: 'viernes', 6: 'sabado', 7: 'domingo' }
			const DIA_A_BLOQUES = {
				1: ['lu1','lu2','lu3','lu4','lu5'], 2: ['ma1','ma2','ma3','ma4','ma5'],
				3: ['mi1','mi2','mi3','mi4','mi5'], 4: ['ju1','ju2','ju3','ju4','ju5'],
				5: ['vi1','vi2','vi3','vi4','vi5'], 6: ['sa1','sa2','sa3','sa4','sa5'],
				7: ['do1','do2','do3','do4','do5']
			}
			const iderp = this.getdatosUsuarioERPERP.iderp
			const campoDia = DIA_A_CAMPO[dia]
			const bloques = DIA_A_BLOQUES[dia] || []
			if(!this.rol || !Array.isArray(this.rol)) return { valido: true }
			const gruposActivos = this.rol.filter(g => g.deleted != 1)
			const horainiNorm = (horaini || '').toString().substr(0, 5)
			const horafinNorm = (horafin || '').toString().substr(0, 5)
			for(const gr of gruposActivos){
				if(!gr[campoDia]) continue
				const grIni = (gr.hora_inicio || '').toString().substr(0, 5)
				const grFin = (gr.hora_fin || '').toString().substr(0, 5)
				if(!grIni) continue
				const haySolapamiento = (horainiNorm < grFin) && (horafinNorm > grIni)
				if(!haySolapamiento) continue
				for(const blq of bloques){
					if(gr[blq] == iderp){
						return { valido: false, grupo: gr.grupo || 'Grupo', hora: grIni }
					}
				}
			}
			return { valido: true }
		},

		addHoraCobertura () {
			if(this.guardandoHoraCobertura) return
			if(!this.horainiCobertura || !this.horafinCobertura){
				this.validarErrorDirecto('Ingresa hora de inicio y fin.')
				return
			}
			if(this.horainiCobertura >= this.horafinCobertura){
				this.validarErrorDirecto('La hora de inicio debe ser menor a la hora de fin.')
				return
			}
			if(!this.diasSeleccionadosCobertura || this.diasSeleccionadosCobertura.length == 0){
				this.validarErrorDirecto('Selecciona al menos un día.')
				return
			}
			const nombresDia = ['','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado','Domingo']
			for(const dia of this.diasSeleccionadosCobertura){
				const validacion = this.validarCoberturaNoConflictiva(dia, this.horainiCobertura, this.horafinCobertura)
				if(!validacion.valido){
					this.validarErrorDirecto(`No puedes agregar cobertura el ${nombresDia[dia]} a las ${validacion.hora}: ya tienes clase asignada en ${validacion.grupo}.`)
					return
				}
			}
			const diasNuevos = this.diasSeleccionadosCobertura.filter(dia =>
				!this.horarioYaExiste(this.coberturaUsuario, dia, this.horainiCobertura, this.horafinCobertura)
			)
			if(!diasNuevos.length){
				this.validarErrorDirecto('Ese horario de cobertura ya está registrado en los días seleccionados.')
				return
			}
			this.guardandoHoraCobertura = true
			const peticiones = diasNuevos.map(dia => {
				const payload = {
					idusuario:        this.getdatosUsuarioERPERP.idusuario,
					inicio:           this.horainiCobertura,
					fin:              this.horafinCobertura,
					usuario_registro: this.getdatosUsuarioERPERP.iderp,
					deleted:          0,
					dia
				}
				return this.$http.post('cobertura.add', payload)
			})
			Promise.all(peticiones).then(()=>{
				this.dialogHoraCobertura = false
				this.horainiCobertura = ''
				this.horafinCobertura = ''
				this.diasSeleccionadosCobertura = []
				this.validarSuccess('Horario de cobertura guardado')
				this.getCoberturaUsuario()
			}).catch(error=>{
				this.validarError(error)
			}).finally(()=>{
				this.guardandoHoraCobertura = false
			})
		},

		deleteItemCobertura (value) {
			this.iddisponibilidad_coberturaDelete = value && (value.iddisponibilidad_cobertura || value.idcobertura_usuario)
			if(!this.iddisponibilidad_coberturaDelete){
				this.validarErrorDirecto('No se pudo identificar el horario de cobertura. Recarga la página e inténtalo de nuevo.')
				return
			}
			this.dialogDeleteHoraCobertura = true
		},

		deleteHoraCobertura () {
			if(this.eliminandoHoraCobertura) return
			if(!this.iddisponibilidad_coberturaDelete){
				this.validarErrorDirecto('No se pudo identificar el horario de cobertura. Recarga la página e inténtalo de nuevo.')
				this.dialogDeleteHoraCobertura = false
				return
			}
			this.eliminandoHoraCobertura = true
			this.$http.delete('cobertura.delete/' + this.iddisponibilidad_coberturaDelete).then(()=>{
				this.dialogDeleteHoraCobertura = false
				this.iddisponibilidad_coberturaDelete = null
				this.validarSuccess('Horario de cobertura eliminado')
				this.getCoberturaUsuario()
			}).catch(error=>{
				this.validarError(error)
			}).finally(()=>{
				this.eliminandoHoraCobertura = false
			})
		},
    },
  }
</script>
<style scoped>
	.separacionAlta{
		padding-top: 100px !important;
		padding-left: 10px !important;
		padding-right: 10px !important;
	}

	.bordesCard{
		border-radius: 14px !important;
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.15)  !important;
	}

	.cardUsuario{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.1)  !important;
	}

  .colorCurso{
  	color:  #5b5b5b;
  }
</style>

